import { render, staticRenderFns } from "./LeadDuplicateCard.vue?vue&type=template&id=0c6dd1a7&scoped=true"
import script from "./LeadDuplicateCard.vue?vue&type=script&lang=js"
export * from "./LeadDuplicateCard.vue?vue&type=script&lang=js"
import style0 from "./LeadDuplicateCard.vue?vue&type=style&index=0&id=0c6dd1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6dd1a7",
  null
  
)

export default component.exports